import { defineMessages } from 'react-intl';

export const cookieDialogMessages = defineMessages({
    title: {
        id: 'cookie.dialog.title',
        defaultMessage: 'Cookie Preferences',
        description: 'Title of the cookie consent dialog',
    },
    body: {
        id: 'cookie.dialog.content',
        defaultMessage:
            "Calm uses tracking technology to understand the way you use our Services and help us to improve it, as well as to personalize content, including by working with third party analytics partners. By clicking 'Accept All', you consent to our use of this technology. You can withdraw your consent or <CookieLink>learn more information</CookieLink>.",
        description: 'Body of the tracking consent dialog',
    },
    acceptAll: {
        id: 'cookie.dialog.acceptAll',
        defaultMessage: 'Accept All',
        description: 'Accept all tracking button',
    },
    essentialOnly: {
        id: 'cookie.dialog.essentialTrackingOnly',
        defaultMessage: 'Essential Tracking Only',
        description: 'Essential tracking only button',
    },
});
